import React, { useState, useEffect, useRef } from 'react';
import '../Styles/HomeTeam.css';
import vijaya from '../images/hometeamphotos/vijaya.webp';
import shambhavi from '../images/hometeamphotos/shambhavi.webp';
import padma from '../images/hometeamphotos/padma.webp';  

// --- Custom Hook ---
const useIntersectionObserver = (options) => {
  const [entry, setEntry] = useState(null);
  const [node, setNode] = useState(null);
  const observer = useRef(null);

  useEffect(() => {
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setEntry(entry);
        observer.current.disconnect(); // Optional: prevent re-trigger
      }
    }, options);

    const { current: currentObserver } = observer;
    if (node) currentObserver.observe(node);

    return () => currentObserver.disconnect();
  }, [node, options]);

  return [setNode, entry];
};

// --- Animation Wrapper ---
const AnimateOnScroll = ({ children, animationClass, style }) => {
  const [ref, entry] = useIntersectionObserver({ threshold: 0.1 });

  return (
    <div
      ref={ref}
      className={`home-team-animate-on-scroll ${entry?.isIntersecting ? animationClass : ''}`}
      style={style}
    >
      {children}
    </div>
  );
};

// --- Main Component ---
const HomeTeam = () => {
  return (
    <div className="home-team-section">
      <AnimateOnScroll animationClass="float-up">
        <h2 className="home-team-title">OUR STYLERS</h2>
        <div className="home-team-title-underline"></div>
      </AnimateOnScroll>

      <div className="home-team-grid">
        <AnimateOnScroll animationClass="pop-up" style={{ animationDelay: '400ms' }}>
          <div className="home-team-employee-card">
            <img src={shambhavi} alt="home-team Member 3" loading="lazy"
            width="400"  height="400" />
            <h3>M Shambhavi</h3>
            <p>Manager & Makeup Artist</p>
          </div>
        </AnimateOnScroll>

        <AnimateOnScroll animationClass="pop-up">
          <div className="home-team-employee-card">
            <img src={vijaya} alt="home-team Member 1" loading="lazy" 
            width="400"   height="400" />
            <h3>Vijaya</h3>
            <p>Hair Dresser & Beautician</p>
          </div>
        </AnimateOnScroll>

        <AnimateOnScroll animationClass="pop-up" style={{ animationDelay: '400ms' }}>
          <div className="home-team-employee-card">
            <img src={padma} alt="home-team Member 4" loading="lazy" />
            <h3>Padma</h3>
            <p>Hair Dresser & Beautician</p>
          </div>
        </AnimateOnScroll>
      </div>
    </div>
  );
};

export default HomeTeam;
